module.exports = __webpack_public_path__ + "img/sendouts-icon.3f8540d8.svg";